// @ts-expect-error no definition
import { DefaultLinesDiffComputer } from "monaco-editor/esm/vs/editor/common/diff/defaultLinesDiffComputer/defaultLinesDiffComputer";
import { IRange } from "monaco-editor";

export interface LinesDiff {
  changes: LineRangeMapping[];
  quitEarly: boolean;
}

interface LineRangeMapping {
  original: LineRange;
  modified: LineRange;
  innerChanges: Change[];
}

interface LineRange {
  startLineNumber: number;
  endLineNumberExclusive: number;
}

interface Change {
  originalRange: IRange;
  modifiedRange: IRange;
}

interface Diff {
  content: string;
  oldText: string;
  newText: string;
}

export function calcDiff(
  orgLines: string[],
  modifiedLines: string[],
): Diff | undefined {
  const computer = new DefaultLinesDiffComputer();
  const linesDiff = computer.computeDiff(orgLines, modifiedLines, {
    ignoreTrimWhitespace: false,
    maxComputationTimeMs: 1000,
    computeMoves: false,
  }) as LinesDiff;
  if (linesDiff.changes.length != 1) {
    return;
  }
  const change = linesDiff.changes[0];
  const originalRange = {
    startLineNumber: change.innerChanges[0].originalRange.startLineNumber,
    startColumn: change.innerChanges[0].originalRange.startColumn,
    endLineNumber:
      change.innerChanges[change.innerChanges.length - 1].originalRange
        .endLineNumber,
    endColumn:
      change.innerChanges[change.innerChanges.length - 1].originalRange
        .endColumn,
  };
  const modifiedRange = {
    startLineNumber: change.innerChanges[0].modifiedRange.startLineNumber,
    startColumn: change.innerChanges[0].modifiedRange.startColumn,
    endLineNumber:
      change.innerChanges[change.innerChanges.length - 1].modifiedRange
        .endLineNumber,
    endColumn:
      change.innerChanges[change.innerChanges.length - 1].modifiedRange
        .endColumn,
  };
  return {
    content: getTextLinesOutsideOfRange(modifiedLines, modifiedRange).join(
      "\n",
    ),
    oldText: getTextLinesInRange(orgLines, originalRange).join("\n"),
    newText: getTextLinesInRange(modifiedLines, modifiedRange).join("\n"),
  };
}

export function calcLinesDiff(
  orgLines: string[],
  modifiedLines: string[],
): LinesDiff {
  const computer = new DefaultLinesDiffComputer();
  const linesDiff = computer.computeDiff(orgLines, modifiedLines, {
    ignoreTrimWhitespace: false,
    maxComputationTimeMs: 1000,
    computeMoves: false,
  }) as LinesDiff;
  return linesDiff;
}

function getTextLinesInRange(lines: string[], range: IRange): string[] {
  const startLine = Math.max(0, range.startLineNumber - 1);
  const endLine = Math.min(lines.length, range.endLineNumber - 1);

  return lines.slice(startLine, endLine + 1);
}

function getTextLinesOutsideOfRange(lines: string[], range: IRange): string[] {
  const startLine = Math.max(0, range.startLineNumber - 1);
  const endLine = Math.min(lines.length, range.endLineNumber - 1);

  return [...lines.slice(0, startLine), "<<MOD>>", ...lines.slice(endLine + 1)];
}
